import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaEye, FaTrash, FaEdit } from 'react-icons/fa';
import { Table, Button, Space, Modal, Input, message, Form } from 'antd';
import '../ViewTable/ViewEmployee.css';
import { fetchVisitorTypesRequest, addVisitorTypesRequest, updateVisitorTypesRequest, deleteVisitorTypesRequest } from '../../redux/actions/visitorTypeActions';

const VisitorTable = () => {
  const dispatch = useDispatch();
  const { visitorTypes = [] , error, visitorTypeAdded} = useSelector((state) => state.visitorType);
  
  const [searchQuery, setSearchQuery] = useState('');
  const [newVisitorType, setNewVisitorType] = useState('');
  const [isAddVisitorTypeModalOpen, setIsAddVisitorTypeModalOpen] = useState(false);
  const [isEditVisitorTypeModalOpen, setIsEditVisitorTypeModalOpen] = useState(false);
  const [isViewVisitorTypeModalOpen, setIsViewVisitorTypeModalOpen] = useState(false);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const [errors, setErrors] = useState({});

  
  useEffect(() => {
    //console.log("effect1");
    
    //console.log("effect3");
    if (error) {
      //console.log("effect4");
      // If there was an error (failure from the saga)
      message.error(error);
      setIsAddVisitorTypeModalOpen(true);
    }
  }, [error]);

  useEffect(() => {
    //console.log("bjebckejbj", visitorTypeAdded);
    if(visitorTypeAdded) {
      //console.log("effect2");
      message.success('Visitor Type Added Successfully');
      setErrors({});
      setIsAddVisitorTypeModalOpen(false);
      setNewVisitorType('');
      dispatch(fetchVisitorTypesRequest());
    }
  }, [visitorTypeAdded, dispatch])
  
  useEffect(() => {
    dispatch(fetchVisitorTypesRequest());
  }, [dispatch]);

  const handleDelete = (visitor) => {
    dispatch(deleteVisitorTypesRequest(visitor));
  };

  const validate = () => {
    const validationErrors = {};
    if (!newVisitorType.trim()) {
      validationErrors.name = 'Visitor type cannot be empty.';
    }
    return validationErrors;
  };

  const handleAddSubmit = async () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        // Assuming the addVisitorTypesRequest action sends the visitor type to backend and returns a response
        dispatch(addVisitorTypesRequest(newVisitorType));
      } catch (error) {
        //console.log("in catch");
        if (error?.response?.data?.message.error) {
          message.error(error.response.data.message.error); 
        } else {
          message.error('An unexpected error occurred.');
        }
      }
    } else {
      message.error('Please correct the errors in the form.');
    }
  };
  
        

  

  const handleEditSubmit = async () => {
    if (!selectedVisitor || !selectedVisitor.visitortype.trim()) {
      message.error('Please provide a valid visitor type.');
      return;
    }
    try {
      // Assuming the updateVisitorTypesRequest action sends the updated visitor type to backend and returns a response
      await dispatch(updateVisitorTypesRequest(selectedVisitor));
      setIsEditVisitorTypeModalOpen(false);
      setSelectedVisitor(null);
    } catch (error) {
      // Handle backend error here (e.g., "visitor type already exists")
      if (error?.response?.data?.message.error) {
        message.error(error.response.data.message.error); // Show the backend error message
      } else {
        message.error('An unexpected error occurred.');
      }
    }
  };

  const columns = [
    {
      title: 'Visitor ID',
      dataIndex: 'id',
    },
    {
      title: 'Visitor Type',
      dataIndex: 'visitortype',
    },
    {
      title: 'Actions',
      render: (_, record) => (
        <Space size="middle">
          <Button icon={<FaEye />} onClick={() => openViewVisitorTypeModal(record)} />
          <Button icon={<FaEdit />} onClick={() => openEditVisitorTypeModal(record)} />
          <Button icon={<FaTrash />} onClick={() => handleDelete(record)} danger />
        </Space>
      ),
    },
  ];

  const filteredVisitorTypes = visitorTypes.filter((visitor) =>
    visitor.visitortype.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const openViewVisitorTypeModal = (visitor) => {
    setSelectedVisitor(visitor);
    setIsViewVisitorTypeModalOpen(true);
  };

  const openEditVisitorTypeModal = (visitor) => {
    setSelectedVisitor(visitor);
    setIsEditVisitorTypeModalOpen(true);
  };

  const closeAddVisitorTypeModal = () => {
    setIsAddVisitorTypeModalOpen(false);
    setNewVisitorType('');
    setErrors({});
  };

  const closeEditVisitorTypeModal = () => {
    setIsEditVisitorTypeModalOpen(false);
    setSelectedVisitor(null);
  };

  const closeViewVisitorTypeModal = () => {
    setIsViewVisitorTypeModalOpen(false);
    setSelectedVisitor(null);
  };

  return (
    <div>
      <div className="actions-container">
        <div className="view-employee-text">View Visitor Types</div>
        <Button type="primary" className="addbutton" onClick={() => setIsAddVisitorTypeModalOpen(true)}
        
          >
          + Add Visitor Type
        </Button>
      </div>

      <div>
        <Input
          type="text"
          placeholder="Search by Visitor Type..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ marginBottom: '20px', padding: '8px', width: '100%' }}
        />
      </div>

      <Table
        columns={columns}
        dataSource={filteredVisitorTypes}
        rowKey="id"
        pagination={false}
        scroll={{ x: 'max-content' }}
        tableLayout="auto"
      />

      {/* Modal for Adding Visitor Type */}
      <Modal
        title="Add Visitor Type"
        open={isAddVisitorTypeModalOpen}
        onCancel={closeAddVisitorTypeModal}
        footer={null}
      >
        <Form layout="vertical" onFinish={handleAddSubmit}>
          <Form.Item 
            label="Visitor Type" 
            required
            validateStatus={errors.name ? 'error' : ''}
            help={errors.name}
          >
            <Input 
              value={newVisitorType} 
              onChange={(e) => setNewVisitorType(e.target.value)} 
              placeholder="Enter new visitor type" 
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" 
             style={{ width: '200px', margin: '0 auto', display: 'block', lineHeight: '5px', }}
            >
              Add Visitor Type 
            </Button>
           
          </Form.Item>
        </Form>


      </Modal>

      {/* Modal for Editing Visitor Type */}
      <Modal
        title="Edit Visitor Type"
        open={isEditVisitorTypeModalOpen}
        onCancel={closeEditVisitorTypeModal}
        footer={null}
      >
        <Form layout="vertical" onFinish={handleEditSubmit}>
          <Form.Item label="Visitor Type" required>
            <Input 
              value={selectedVisitor?.visitortype || ''}
              onChange={(e) => setSelectedVisitor({ ...selectedVisitor, visitortype: e.target.value })} 
              placeholder="Edit visitor type" 
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit"
             style={{ width: '200px', margin: '0 auto', display: 'block', lineHeight: '5px', }}
            >
              Save Changes</Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal for Viewing Visitor Type */}
      <Modal
        title="View Visitor Type"
        open={isViewVisitorTypeModalOpen}
        onCancel={closeViewVisitorTypeModal}
        footer={null}
        width={250}
        centered
      >
        <p><strong>Visitor Type:</strong> {selectedVisitor?.visitortype}</p>
      </Modal>

      

    </div>
  );
};

export default VisitorTable;
